import { useState } from "react";
import styles from "./index.module.scss";
import { useTranslation } from "../../../../hooks/useTranslation";
import { Input } from "../../../ui/input";
import { Radio } from "../../../ui/radio";
import { Button } from "../../../ui/button";
import { useLanguage } from "../../../../hooks/useLanguage";

export enum SOLUTION_TYPES {
    LANDING = "landing",
    SHOWCASE = "showcase",
    APPLICATION = "application",
    UNSURE = "unsure"
}

export const Contact = () => {
    const { t } = useTranslation();
    const { language } = useLanguage();
    
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [mail, setMail] = useState("");
    const [phone, setPhone] = useState("");
    const [message, setMessage] = useState("");
    const [solutionType, setSolutionType] = useState<SOLUTION_TYPES | null>(null);

    const bodyFR = 
`Bonjour,

J'essaye de vous contacter via votre site web : https://timothee.app/

Voici mes informations :
• Prénom: ${firstName}
• Nom: ${lastName}
• Adresse mail: ${mail}
• Téléphone: ${phone}

Voici mon besoin : ${solutionType}

Voici mon message :

${message}

Cordialement,
${firstName} ${lastName}
`;
    const bodyEN = 
`Hello,

I am trying to contact you via your website: https://timothee.app/

Here is my information:
• First name: ${firstName}
• Last name: ${lastName}
• Email address: ${mail}
• Phone: ${phone}

Here is my need: ${solutionType}

Here is my message:

${message}

Best regards,
${firstName} ${lastName}
`;
    const body = language === 'fr' ? bodyFR : bodyEN;
    
    const subject = `Contact - ${firstName} ${lastName}`;
    const mailtoHref = `mailto:contact@timothee.app?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    return (
        <div className={styles.footer}>
            <div className={styles.title}>
                <h3>{t('contact.title')}</h3>
                <p>{t('contact.description')}</p>
            </div>
            <div className={styles.contact}>
                <div className={styles.name}>
                    <Input type="text" placeholder={t('contact.firstname')} value={firstName} onChange={(e) => setFirstName(e)} length="short" />
                    <Input type="text" placeholder={t('contact.lastname')} value={lastName} onChange={(e) => setLastName(e)} length="short" />
                </div>
                <Input type="email" placeholder={t('contact.email')} value={mail} onChange={(e) => setMail(e)} length="short" />
                <Input type="tel" placeholder={t('contact.telephone')} value={phone} onChange={(e) => setPhone(e)} length="short" />
            </div>
            <div className={styles.message}>
                <p>Type de solution</p>
                <div className={styles.radios}>
                {
                    Object.values(SOLUTION_TYPES).map((solution) => (
                        <label key={solution} className={styles.pill + (solution === solutionType ? ' ' + styles.selected : '')}>
                            <Radio
                                value={solution}
                                checked={solution === solutionType}
                                onChange={() => setSolutionType(solution)}
                            />
                        </label>
                    ))
                }
                </div>
                <Input type="text" placeholder={t('contact.message')} value={message} onChange={(e) => setMessage(e)} length="long" />
                <a href={mailtoHref}>
                    <Button color="black" isFullWidth onClick={() => {}}>
                        <p>{t('global.contact')}</p>
                    </Button>
                </a>
                <p className={styles.alternative}>
                    {t('contact.alternative')}
                    <a href="mailto:contact@timothee.app">contact@timothee.app</a>
                </p>
            </div>
        </div>
    );
};